import { render, staticRenderFns } from "./serviceitem-dialog-selector-instance.vue?vue&type=template&id=13017580&"
import script from "./serviceitem-dialog-selector-instance.vue?vue&type=script&lang=js&"
export * from "./serviceitem-dialog-selector-instance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports